var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinalAssigSubmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.191,
    height: 21.194,
    viewBox: "0 0 21.191 21.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "submit-success-check-mark-svgrepo-com",
    transform: "translate(-31.42 -30.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M50.3,54.442a.673.673,0,0,0-1.1.767,8.743,8.743,0,1,1-9.671-3.383.673.673,0,0,0-.383-1.291A10.091,10.091,0,1,0,50.3,54.442Z",
    transform: "translate(0 -18.678)",
    fill: "#136ad0",
    stroke: "#136ad0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M227.917,33.148a8.7,8.7,0,0,1,2.885,1.513.673.673,0,0,0,.834-1.056,10.02,10.02,0,0,0-3.363-1.749.673.673,0,1,0-.383,1.291Zm-2.972-.558a.773.773,0,0,0,.222.141.632.632,0,0,0,.511,0,.78.78,0,0,0,.222-.141.673.673,0,0,0,.2-.477.706.706,0,0,0-.2-.477.673.673,0,0,0-.612-.2.437.437,0,0,0-.121.04.5.5,0,0,0-.121.061l-.1.081a.687.687,0,0,0-.141.746A.78.78,0,0,0,224.944,32.59ZM219.5,40.6a.767.767,0,0,0,0,1.089l3.847,3.874a.767.767,0,0,0,1.089,0l6.913-6.947a.782.782,0,1,0-1.089-1.123l-6.375,6.375-3.3-3.268A.773.773,0,0,0,219.5,40.6Z",
    transform: "translate(-183.399 0)",
    fill: "#136ad0",
    stroke: "#136ad0",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalAssigSubmission);
export default __webpack_public_path__ + "static/media/final-assig-submission.c60fcab5d8cd2daab82fb663282d8c9b.svg";
export { ForwardRef as ReactComponent };